import React from 'react';
import {Card, Icon} from "@blueprintjs/core";
import gql from 'graphql-tag';
import {useQuery} from "@apollo/client";
import styled from 'styled-components';
import {useHistory} from "react-router";

const StyledCard = styled(Card)`
  min-width: 400px;
  max-width: 800px;
  
  text-align: center;
`

const TEAM_QUERY = gql`
    query($teamId: Int!) {
        team(id: $teamId) {
            id
            displayName: name(format: WITH_DIVISION_AND_MODIFIER)
            division {
                id
                name
            }
            record
        }
    }
`

export const TeamSummaryCard = ({ teamId, clearTeamId }) => {

  const { data } = useQuery(TEAM_QUERY, {
    variables: {
      teamId
    },
    fetchPolicy: 'no-cache'
  })

  const history = useHistory()

  if (!data) return ''

  const { displayName, record } = data.team

  return (
    <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
      <StyledCard style={{position: 'relative', padding: '15px', width: '100%'}}>
        <div
          style={{color: '#669EFF', cursor: 'pointer', borderBottom: '0px solid lightgrey', width: '100%', display: 'flex', justifyContent: 'row', marginBottom: '5px'}}
          onClick={() => {
            clearTeamId()
            history.push({pathname: history.pathname})
          }}
        >
          <Icon icon={'arrow-left'} />
          <h3 style={{display: 'inline-block', lineHeight: '18px', margin: 0, marginLeft: '5px', padding: 0, fontWeight: '600'}}>Choose Another Team</h3>
        </div>

        <h2 style={{margin: 0, padding: 0}}>{displayName}</h2>
        <h3 style={{margin: 0, marginTop: '5px', padding: 0}}>{record}</h3>
      </StyledCard>
    </div>
  )
}
